import React, { useState, useEffect } from 'react';
import Layout from './Layout';
import { GlobalErrorContext, SettingsContext } from './../context';
import {
  ResponseErrorBody,
  ErrorCodes,
  Width,
  ResponseErrorBodyOldUser
} from '../types';
import ErrorDeviceBlocked from './ErrorDeviceBlocked';
import ErrorUnconfirmedEmail from './ErrorUnconfirmedEmail';
import ErrorUserBlocked from './ErrorUserBlocked';
import ErrorNewLocation from './ErrorNewLocation';
import ErrorOldUser from './ErrorOldUser';
import ErrorLoginAccess from './ErrorLoginAccess';
import { Snackbar, SnackbarContent } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import i18n from '../i18n';
import NewDevice from './NewDevice';
import ErrorThreatIp from './ErrorThreatIp';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  error: {
    backgroundColor: theme.palette.error.dark
  }
}));

/**
 * Common Page, above Layout
 * @param props
 */
export default function(props: { children: React.ReactNode }) {
  const classes = useStyles();
  const [globalError, setGlobalError] = useState<ResponseErrorBody | string>();
  const [language, setLanguage] = useState(i18n.language);
  const [layoutWidth, setLayoutWidth] = useState<Width>(false);

  useEffect(() => {
    i18n.on('languageChanged', (language: string) => {
      setLanguage(language);
    });
  }, []);

  let content;
  let snackbarError;
  if (globalError) {
    if (typeof globalError !== 'string') {
      switch (globalError.code) {
        case ErrorCodes.UNAUTHORIZED_DEVICE:
          content = <ErrorDeviceBlocked />;
          break;
        case ErrorCodes.NEW_DEVICE:
          content = <NewDevice />;
          break;
        case ErrorCodes.UNCONFIRMED_EMAIL:
          content = <ErrorUnconfirmedEmail error={globalError} />;
          break;
        case ErrorCodes.BLOCKED_USER:
        case ErrorCodes.USER_BLOCKED:
          content = <ErrorUserBlocked />;
          break;
        case ErrorCodes.THREAT_IP:
          content = <ErrorThreatIp />;
          break;
        case ErrorCodes.NEW_LOCATION:
          content = <ErrorNewLocation error={globalError} />;
          break;
        case ErrorCodes.OLD_USER:
          content = (
            <ErrorOldUser error={globalError as ResponseErrorBodyOldUser} />
          );
          break;
        case ErrorCodes.LOGIN_ACCESS:
          content = <ErrorLoginAccess />;
          break;
        default:
          content = props.children;
          snackbarError = 'Internal Error';
          break;
      }
    } else {
      content = props.children;
      snackbarError = globalError;
    }
  } else {
    content = props.children;
  }
  return (
    <SettingsContext.Provider
      value={{
        layoutWidth,
        language,
        setLanguage,
        setLayoutWidth
      }}
    >
      <Layout maxWidth={layoutWidth}>
        <GlobalErrorContext.Provider
          value={{
            globalError,
            setGlobalError
          }}
        >
          <Snackbar
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            open={!!snackbarError}
            autoHideDuration={6000}
          >
            <SnackbarContent
              className={classes.error}
              message={<span id="client-snackbar">{snackbarError}</span>}
            />
          </Snackbar>
          {content}
        </GlobalErrorContext.Provider>
      </Layout>
    </SettingsContext.Provider>
  );
}
